// extracted by mini-css-extract-plugin
export default {"suspenseSections":"styles_suspenseSections__x9hch","heading":"styles_heading__LlcId","helpIcon":"styles_helpIcon__lr22w","marginBottom35":"styles_marginBottom35__lBPyp"};